import React from 'react';
import Image from 'components/UI/Image';
import Title from 'components/UI/Title';
import Link from 'components/UI/Link';
import { useTrans } from 'utils/localisation';

import * as styles from './TopProjectsSlide.module.scss';

export default function TopProjectSlide({ title, link, image, handlePushEvent }) {
  const t = useTrans(['topProjects']);

  const handleCardClick = () => {
    handlePushEvent('click_on_card');
  };

  const handleLinkClick = () => {
    handlePushEvent('click_on_button');
  };

  return (
    <div className={styles.container} onClick={handleCardClick}>
      <Image className={styles.picture} classImage={styles.img} src={image} alt={title} />
      <div className={styles.layout}>
        <Title className={styles.title} size="h1Cases">
          {title}
        </Title>
        <Link className={styles.link} href={link} onClick={handleLinkClick}>
          {t('readSuccessStory')}
        </Link>
      </div>
    </div>
  );
}
